module.exports = __webpack_public_path__ + "f49657875c7a402312ec1484e2d6a7be.svg";